import React, { useState, useEffect, useCallback } from "react";

import translations from "./cookie-consent-translations";

const STORAGE_KEY = "davoyage-cookie-consent";

const GA4_ID = "G-8XCNXRCRF5";
const ADS_ID = "AW-937429566";

// Consent Mode v2 signals. Google tags only load after the visitor accepts (basic mode).
const consent = (value) => ({
  ad_storage: value,
  ad_user_data: value,
  ad_personalization: value,
  analytics_storage: value,
});

function loadAnalytics() {
  if (window.gtag) {
    window.gtag("consent", "update", consent("granted"));
    return;
  }

  const script = document.createElement("script");
  script.id = "ga-gtag-script";
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=" + GA4_ID;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("consent", "default", consent("granted"));
  gtag("js", new Date());
  gtag("config", GA4_ID);
  gtag("config", ADS_ID);
}

// Events sent before the visitor answers the banner wait here, and only go out if they accept.
const pendingEvents = [];

// Sends a GA4 / Google Ads event, only if the visitor accepted cookies.
export const trackEvent = (name, params) => {
  const choice = localStorage.getItem(STORAGE_KEY);
  if (choice === "accepted" && window.gtag) {
    window.gtag("event", name, params);
  } else if (choice === null) {
    pendingEvents.push([name, params]);
  }
};

const CookieConsent = (props) => {
  const t = translations[props.lang] || translations.fr;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "accepted") {
      loadAnalytics();
    } else if (stored !== "refused") {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener("open-cookie-consent", reopen);
    return () => window.removeEventListener("open-cookie-consent", reopen);
  }, []);

  const accept = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    loadAnalytics();
    pendingEvents.splice(0).forEach(([name, params]) => window.gtag("event", name, params));
    setVisible(false);
  }, []);

  const refuse = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, "refused");
    pendingEvents.length = 0;
    if (window.gtag) window.gtag("consent", "update", consent("denied"));
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label={t.ariaLabel}>
      <p className="cookie-banner-text">{t.text}</p>
      <div className="cookie-banner-actions">
        <button className="cookie-refuse" onClick={refuse}>{t.refuse}</button>
        <button className="cookie-accept" onClick={accept}>{t.accept}</button>
      </div>
    </div>
  );
};

export default CookieConsent;
